import { DataService } from '../../../services/data_service';
import { IDs } from '../../../helpers/IDs';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';

export interface DatenverwaltungSystemtexteZuordnungProps {
    data: any;
}

export interface DatenverwaltungSystemtexteZuordnungState {
    bundle: any;
    systemtexte: any;
}

export class DatenverwaltungSystemtexteZuordnung extends
    React.Component<DatenverwaltungSystemtexteZuordnungProps, DatenverwaltungSystemtexteZuordnungState> {

    constructor(props: any) {
        super(props);
        this.state = {
            bundle: null,
            systemtexte: null
        };
        this.customFormatter = this.customFormatter.bind(this);
    }

    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    componentDidMount(): void {
        this.init();
    }

    customFormatter(field: string, value: any, data: any, row: any): any {
        return field === 'systemtext' && ((this.state.systemtexte || {})[value] || []).length > 1
            ? `${value} (${this.state.systemtexte[value].indexOf(data.systemtext_orig || data.systemtext) + 1})`
            : value;
    }

    init(): void {
        const data: any = {};
        this.dataService.loadData(
            IDs.ENT_SYSTEMTEXTE, {}, {},
            (result: any) => {
                const systemtext: Array<any> = (result || {})[IDs.ENT_SYSTEMTEXTE] || [];

                ((result || {})[IDs.ENT_SYSTEMTEXTE] || [])
                    .sort((a: any, b: any) => a.tid - b.tid)
                    .forEach((item: any) => {
                        if (typeof data[item.name] === 'undefined') {
                            data[item.name] = [];
                        }
                        data[item.name].push(item.tid);
                    });

                systemtext.forEach((item: any, index: number) => {
                    const name: string = item.name || null;
                    systemtext[index].name = data[name].length > 1
                        ? `${name} (${data[name].indexOf(item.tid) + 1})`
                        : name;
                });
                this.setState({ bundle: { systemtext }, systemtexte: data });
            },
            IDs.MOD_ETOOL_ADMIN
        );
    }

    render(): JSX.Element {
        if (!this.state.bundle) {
            return null;
        }

        return (
            <WFormsTableWrapper
                entity={IDs.ENT_SYSTEMTEXTE_ZUORDNUNG}
                module={IDs.MOD_ETOOL_ADMIN}
                actions={['add', 'edit', 'delete']}
                formLayout='flowV2'
                customClass='Custom-ETA'
                bundleFilterFunc={(bundle: any) => bundle.systemtext = this.state.bundle.systemtext || bundle.systemtext}
                onSaveDone={() => this.triggerService.fire('reload', IDs.ENT_SYSTEMTEXTE_ZUORDNUNG)}
                customFormatter={this.customFormatter}
                showColumnsHelp={true}
            />
        );
    }
}
